<template>
  <div class="wait-container" :class="{ 'wait-container--full-height': fullHeight }">
    <div class="wait-content">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <p v-if="message" class="wait-message">{{ message }}</p>
    </div>
  </div>
</template>

<script setup>
defineProps({
  message: {
    type: String,
    default: '',
  },
  fullHeight: {
    type: Boolean,
    default: false,
  },
});

defineOptions({
  name: 'Wait',
});
</script>

<style lang="scss" scoped>
.wait-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100px;
}

.wait-container--full-height {
  @include full-vh(min-height);
}

.wait-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.wait-message {
  margin: 12px 0 0;
  font-size: 1rem;
  color: var(--body-text-color, #333);
  text-align: center;
}

.lds-ring {
  /* change color here */
  color: var(--color-primary);
}
.lds-ring,
.lds-ring div {
  box-sizing: border-box;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid currentColor;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: currentColor transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
